import * as React from 'react';
var IsRestoringContext = /*#__PURE__*/React.createContext(false);
var useIsRestoring = function useIsRestoring() {
  return React.useContext(IsRestoringContext);
};
var IsRestoringProvider = IsRestoringContext.Provider;
export { IsRestoringProvider, useIsRestoring };